<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ `${$route.meta.title}` | t }}</v-toolbar-title>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="800">
            <notification-center-view v-if="$route.name === 'notification-center-view'" />
        </v-navigation-drawer>
        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <!-- Footer -->
        <page-footer />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import { mapState } from "vuex";
import Store from "../store";
import NotificationCenterView from "../pages/notification-center/notification-center-view";

export default {
    name: "notification-center",
    components: {
        PageFooter,
        MainDrawer,
        NotificationCenterView
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                await this.$router.push({ name: "notification-center-list" });
            }
            if (
                this.activeNotification &&
                Object.keys(this.activeNotification).length > 0 &&
                document.activeElement.tagName !== "INPUT"
            ) {
                await Store.commit("NotificationCenterStore/resetActiveNotificationData");
                let currentNotificationIndex = this.notifications.findIndex(p => p.id === this.activeNotification.id);
                if (e.key === "ArrowUp") {
                    if (currentNotificationIndex !== 0) {
                        const newNotificationId = this.notifications[currentNotificationIndex - 1].id;
                        await Store.dispatch("NotificationCenterStore/getNotificationData", newNotificationId);
                        await this.$router.push({
                            name: this.$route.name,
                            params: { notificationId: newNotificationId }
                        });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentNotificationIndex + 1 !== this.notifications.length) {
                        const newNotificationId = this.notifications[currentNotificationIndex + 1].id;
                        await Store.dispatch("NotificationCenterStore/getNotificationData", newNotificationId);
                        await this.$router.push({ name: this.$route.name, params: { invoiceId: newNotificationId } });
                    }
                }
            }
        }
    },
    computed: {
        ...mapState("NotificationCenterStore", ["drawerOpen", "requestSuccess", "activeNotification", "notifications"])
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
